//src\design-system\Organisms\NotificationSection\notificationList.tsx

import { useState } from "react";
import type { FC } from "react";
import { NotificationAccordionItem } from "./NotificationAccordionItem";
import type { Notification } from "@/rtkQuery/features/models/notification.model";

interface NotificationListProps {
  data: Notification[];
}

export const NotificationList: FC<NotificationListProps> = ({ data }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const handleToggle = (index: number) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <div>
      {data && data?.map((item, index) => (
        <NotificationAccordionItem
          key={index}
          notification={item}
          isOpen={openIndex === index}
          onToggle={() => handleToggle(index)}
        />
      ))}
    </div>
  );
}; 